import profileActions from "actions/profile";
import AddCars from "components/connectCars/addCars";
import CreateRelay from "components/connectCars/createRelay";
import { paths } from "helpers/paths";
import { hasValue, ymEvent } from "helpers/system";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { closeRelayConnectingModal } from "sources/relays";

export const getRelayConnectionInitialStep = (relay = {}) => {
    const hasRelaySettings = hasValue(relay.retType) && hasValue(relay.retId);

    return hasRelaySettings || relay.initStatus === "Success" ? "cars" : "connect";
};

const RelayConnection = ({ back, closeState, initialStep = "connect", source, organization, enums, getOrg }) => {
    const [step, setStep] = useState(initialStep);
    const [dontShowAgain, setDontShowAgain] = useState(closeState?.dontShowAgain ?? false);
    const history = useHistory();

    const updateStep = (value) => {
        if (closeState) {
            closeState.step = value;
        }
        setStep(value);
    };

    const updateDontShowAgain = (value) => {
        if (closeState) {
            closeState.dontShowAgain = value;
        }
        setDontShowAgain(value);
    };

    const handleDontShowAgainClick = () => {
        const nextValue = !dontShowAgain;

        if (nextValue) {
            ymEvent("RelayConnectionModalDontShowAgainClicked");
        }

        updateDontShowAgain(nextValue);
    };

    const handleCarsSaved = () => {
        back();
        history.push(paths.root);
    };

    return (
        <div className={`relay-connection-modal relay-connection-modal--${step}`}>
            {step === "connect" ? (
                <div className="relay-connection-modal__connect">
                    <CreateRelay
                        modalMode
                        organization={organization}
                        getOrg={getOrg}
                        onConnected={() => updateStep("cars")}
                        connectionSource={source}
                        beforeContainer={
                            <div className="relay-connection-modal__headline">
                                Подключите вашу систему gps-мониторинга и управляйте парком как крупная транспортная
                                компания
                            </div>
                        }
                        afterContainer={
                            <label className="relay-connection-modal__dont-show">
                                <span
                                    className={`checkbox relay-connection-modal__dont-show-checkbox ${
                                        dontShowAgain ? "checkbox--checked" : ""
                                    }`}
                                    onClick={handleDontShowAgainClick}
                                />
                                <span onClick={handleDontShowAgainClick}>Больше не спрашивать</span>
                            </label>
                        }
                    />
                </div>
            ) : (
                <AddCars
                    embeddedMode="relayConnection"
                    organization={organization}
                    enums={enums}
                    getOrg={getOrg}
                    onSaved={handleCarsSaved}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    organization: state.profile.organization,
    enums: state.dictionaries.enums,
});

const mapDispatchToProps = (dispatch) => ({
    getOrg: () => dispatch(profileActions.getOrg()),
});

const ConnectedRelayConnection = connect(mapStateToProps, mapDispatchToProps)(RelayConnection);

const createCloseState = (initialStep) => ({ dontShowAgain: false, step: initialStep });

export const getRelayConnectionModalParams = (getOrg, { initialStep = "connect", source } = {}) => {
    const closeState = createCloseState(initialStep);

    return {
        name: "default",
        CustomBody: ConnectedRelayConnection,
        bodyData: { closeState, initialStep, source },
        withoutHeader: true,
        withoutEscClose: true,
        mod: "relay-connection",
        onClose: () => {
            if (closeState.step !== "connect") {
                return;
            }

            if (!closeState.dontShowAgain) {
                ymEvent("RelayConnectionModalLaterClicked");
            }

            return closeRelayConnectingModal({ dontShowAgain: closeState.dontShowAgain }).then((res) => {
                if (res) {
                    getOrg?.();
                }
            });
        },
    };
};

export default ConnectedRelayConnection;
